import React from 'react'
import { Grid, useTheme } from '@mui/material'
import { getLogo } from 'utils/helpers'

const LogoLogin = () => {
  const theme = useTheme()

  return (
    <Grid
      id="container-login-logo"
      container
      direction="row"
      alignItems="baseline"
      style={{
        flexWrap: 'nowrap',
        backgroundColor: 'transparent'
      }}
    >
      <img
        id="login-logo-hub"
        src={getLogo(true, theme.palette.mode === 'dark')}
        alt="logo"
        style={{ width: '130px' }}
      />
    </Grid>
  )
}
export default LogoLogin
